import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-sales-credit-codes-shared',
  templateUrl: './sales-credit-codes-shared.component.html'
})
export class SalesCreditCodesSharedComponent {
  @Input() otp?: string | null;
  @Input() contractNumber?: string | null;
  @Input() personNumber?: string | null;

  get hasContent(): boolean {
    return !!this.otp || !!this.contractNumber || !!this.personNumber;
  }
}
